import * as React from 'react';
import Grid from '@material-ui/core/Grid';

interface BatchInputCodeTableViewCellProps {
    code: string,
    fullName: string
}

class BatchInputCodeTableViewCell extends React.Component <BatchInputCodeTableViewCellProps, {}> {
    public render() {
        return (
            <div className="cmTableViewCell cmText batchInputCodeTableViewCell">
                <Grid className="cmTableViewCol" item xs={3}>
                    <div className="batchInputCodeTableViewCellData">{this.props.code}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={9}>
                    <div>{this.props.fullName}</div>
                </Grid>
            </div>
        );
    }
}

export default BatchInputCodeTableViewCell;



// WEBPACK FOOTER //
// ./src/Components/Batch/BatchInputCodeTableViewCell.tsx